import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=291b3077&scoped=true&"
import script from "./leave.vue?vue&type=script&lang=js&"
export * from "./leave.vue?vue&type=script&lang=js&"
import style0 from "./leave.vue?vue&type=style&index=0&id=291b3077&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291b3077",
  null
  
)

export default component.exports